const ScreenReader = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="96" height="96" rx="48" />
      <path
        d="M22.3359 28.167L73.3359 28.167"
        stroke="black"
        strokeWidth="5.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g filter="url(#filter0_f_127_3155)">
        <path
          d="M22.3359 47.9995L73.3359 47.9995"
          stroke="black"
          strokeWidth="5.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g filter="url(#filter1_f_127_3155)">
        <path
          d="M22.3359 67.8325L73.3359 67.8325"
          stroke="black"
          strokeWidth="5.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.2826 63.8993C44.9918 61.0717 44.8849 56.2515 44.8311 53.8283C44.8175 53.2132 44.8073 52.7526 44.7983 52.5181L44.3369 41.8257C44.1398 37.2862 49.1011 34.3924 52.9553 36.7988L56.1587 38.8058C56.294 38.8928 56.5707 39.0646 56.9424 39.2955C57.9208 39.9029 59.5577 40.9193 61.0084 41.876C61.042 41.8943 61.0753 41.9138 61.1082 41.9345L72.4949 49.0471C77.1452 51.939 75.3483 59.0853 69.8922 59.4371L63.5206 59.8479C61.7488 59.9695 60.147 60.9037 59.1689 62.3861L55.6746 67.7299C52.6682 72.3141 45.5491 70.3683 45.3213 64.8968L45.2826 63.8993Z"
        fill="black"
      />
      <defs>
        <filter
          id="filter0_f_127_3155"
          x="15.5352"
          y="41.1997"
          width="64.6016"
          height="13.5996"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.125"
            result="effect1_foregroundBlur_127_3155"
          />
        </filter>
        <filter
          id="filter1_f_127_3155"
          x="15.5352"
          y="61.0327"
          width="64.6016"
          height="13.5996"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.125"
            result="effect1_foregroundBlur_127_3155"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ScreenReader;
